<template>
  <div class="h-full w-full">
    <MarketMap
      :data="portfolioMap"
      :hovered-component="MarketMapSymbolDetail"
      hovered-component-height="700"
      :on-click-callback="handleOnClick"
      :header-height="0"
      :dark-mode="colorMode === 'dark'"
    />
  </div>
</template>

<script setup lang="ts">
import { MarketMap } from '@next-market-map-api/marketmap';
import { TreeMapDataType } from '@core/portfolio';
import { ORDER_TYPES } from '@core/order';
import { useColorMode } from '@vueuse/core';

import { MarketMapSymbolDetail } from '@/modules/symbol';
import { useOrderDialogs } from '@/modules/order';

type PortfolioMarketMapProps = {
  portfolioMap: TreeMapDataType;
};

defineProps<PortfolioMarketMapProps>();

const { openNewOrderFormDialog } = useOrderDialogs();

const handleOnClick = ({ isin, name }: { isin: string; name: string }) => {
  openNewOrderFormDialog({
    type: ORDER_TYPES.buy,
    symbol: { isin, instrumentName: name },
  });
};

const colorMode = useColorMode();
</script>
